import {Input} from '@shared/FormsComponents/Input/Input';
import {FC} from 'react';
import {Control, Controller} from 'react-hook-form';

import {FormItem} from '@shared/SupportModal/types';

import useValidationRules from '@utils/hooks/useValidationRules';

type FormValues = Record<string, string>;

type Props = {
  formItem: FormItem;
  control: Control<FormValues | any>;
  className?: string;
  withLettersCounterInTextArea?: boolean;
};

export const FormField: FC<Props> = ({
  formItem,
  control,
  className,
  withLettersCounterInTextArea,
}) => {
  const {inputName, optional, label, placeholder, isTextArea} = formItem;
  const rules = useValidationRules(formItem);

  return (
    <Controller
      control={control}
      name={inputName}
      rules={rules}
      render={({fieldState, field: {value, ...restField}}) => (
        <Input
          {...restField}
          label={label}
          placeholder={placeholder}
          optional={optional}
          textarea={isTextArea}
          error={fieldState.error}
          className={className}
          inputName={inputName}
          withLettersCounterInTextArea={withLettersCounterInTextArea}
          rules={rules}
          value={value}
        />
      )}
    />
  );
};
